"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SemVer = exports.Version = void 0;
class Version {
}
exports.Version = Version;
/**
 * Small subset of SemVer spec -- the relevant versions in this app are all major.minor.patch (all numbers)
 * Grab https://github.com/npm/node-semver if more complete functionality is needed
 */
//TODO change uses to leverage version pipe instead
class SemVer {
    constructor(versionString) {
        this.isValid = true;
        let parts = versionString.split('.');
        if (parts.length != 3) {
            this.isValid = false;
        }
        else {
            [this.major, this.minor, this.patch] = parts.map(i => parseInt(i));
            if (this.asArray().filter(i => isFinite(i) && i >= 0).length != 3) {
                this.isValid = false;
            }
        }
    }
    asArray() {
        return [this.major, this.minor, this.patch];
    }
    asString() {
        return this.isValid ? this.asArray().join('.') : '?';
    }
    /**
     * compare function used for sorting
     */
    cmp(other) {
        if (!(other instanceof SemVer)) {
            other = new SemVer(other);
        }
        let b = other.asArray();
        return this.asArray().map((item, idx) => item - b[idx]).filter(i => i)[0] || 0;
    }
}
exports.SemVer = SemVer;
//# sourceMappingURL=version.js.map